export default "__VITE_ASSET__DBe3NcMS__"